import React from "react";

function Portfolio() {
  return <div className="center">Portfolio</div>;
}

export default Portfolio;
